<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-editor :config="{id: gridConfig.id, api: 'Labels/Get/'}"/>
  </div>
</template>
<script>
import gridConfig from './GridConfig'

export default {
  name: 'LabelsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-editor': () => import(/* webpackChunkName: 'Labels' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
